import axios from "@/api/http"; // 导入http中创建的axios实例
import base from "@/api/base";
import doctor from "./user"; // 导入接口域名列表

const postReview = {
  queryPostReviewCount(data) {
    return axios.get(
      `${base.baseURL_clinic}/posts/getReviewCount?searchText=${data.searchText}`,);
  },
  queryPostReviewPage(data) {
    return axios.get(
      `${base.baseURL_clinic}/posts/getReview?currentPage=${data.currentPage}&pageSize=${data.pageSize}&searchText=${data.searchText}`,);
  },

  allowPost(data) {
    return axios.post(
      `${base.baseURL_clinic}/posts/allowPost?id=${data.id}`,);
  },
  disallowPost(data) {
    return axios.post(
      `${base.baseURL_clinic}/posts/disallowPost?id=${data.id}`,);
  },

  queryConsultantReviewCount(data) {
    return axios.get(
      `${base.baseURL_clinic}/userDetail/getReviewCount?status=${data.status}&searchText=${data.searchText}`);
  },
  queryConsultantReviewPage(data) {
    return axios.get(
      `${base.baseURL_clinic}/userDetail/getReview?currentPage=${data.currentPage}&pageSize=${data.pageSize}&status=${data.status}&searchText=${data.searchText}`,);
  },
  allowConsultant(data) {
    return axios.post(
      `${base.baseURL_clinic}/userDetail/allowReview?id=${data.id}`,);
  },

  disallowConsultant(data) {
    return axios.post(
      `${base.baseURL_clinic}/userDetail/disallowReview?id=${data.id}`,);
  },

}
export default postReview;



// WEBPACK FOOTER //
// ./src/network/postReview.js